import { render, staticRenderFns } from "./ProductDetailSku.vue?vue&type=template&id=bfd3028a&scoped=true&"
import script from "./ProductDetailSku.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailSku.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailSku.vue?vue&type=style&index=0&id=bfd3028a&prod&scoped=true&lang=css&"
import style1 from "./ProductDetailSku.vue?vue&type=style&index=1&id=bfd3028a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd3028a",
  null
  
)

export default component.exports